import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Tooltip, { POSITION, ALIGN } from 'gnos-tooltip'
import { FormattedMessage } from 'react-intl'
import cx from 'classnames'

import { WS_ENTITY_STACK_REMOVE_NOTIFICATION } from '../../../StackContent/components/ExportsContent/constants'
import { sendMessage } from '../../../../../../../../services/socket/helpers'

import { LOCALE_PREFIX } from './constants'

import './style.scss'

export default class Tab extends Component {
    static propTypes = {
        activeTab: PropTypes.string.isRequired,
        entityStackRemoveNotification: PropTypes.func.isRequired,
        hasNotification: PropTypes.bool,
        changeEntityStackTab: PropTypes.func.isRequired,
        swChangeEntityStackTab: PropTypes.func.isRequired,
        type: PropTypes.string.isRequired,
    }

    handleOnTabClick = () => {
        const { changeEntityStackTab, type, activeTab, swChangeEntityStackTab, entityStackRemoveNotification } =
            this.props

        if (type !== activeTab) {
            changeEntityStackTab(type)
            swChangeEntityStackTab(type)

            sendMessage(WS_ENTITY_STACK_REMOVE_NOTIFICATION, { tabType: type })
            entityStackRemoveNotification(type)
        }
    }

    render() {
        const { type, activeTab, hasNotification } = this.props

        return (
            <Tooltip
                id={`entity-stack-type-${type}-tooltip`}
                content={
                    <FormattedMessage
                        id={`${LOCALE_PREFIX}.tooltip.${type}`}
                        values={{ br: <br />, b: (chunks) => <b>{chunks}</b> }}
                    />
                }
                position={POSITION.BOTTOM}
                align={ALIGN.START}
            >
                <div
                    className={cx(
                        'entity-stack-tab',
                        type,
                        activeTab === type && 'active',
                        hasNotification && activeTab !== type && 'with-notification'
                    )}
                    onClick={this.handleOnTabClick}
                />
            </Tooltip>
        )
    }
}
